/**
 * Liste des villes françaises
 */
export class GeoVille {
    constructor(row) {
        var _a, _b, _c, _d, _e, _f;
        if (row) {
            this.idVille = (_a = row.idVille) !== null && _a !== void 0 ? _a : null;
            this.idDepartement = (_b = row.idDepartement) !== null && _b !== void 0 ? _b : null;
            this.cp = (_c = row.cp) !== null && _c !== void 0 ? _c : null;
            this.libelle = (_d = row.libelle) !== null && _d !== void 0 ? _d : null;
            this.libelleUrlRewriting = (_e = row.libelleUrlRewriting) !== null && _e !== void 0 ? _e : null;
            this.codePays = (_f = row.codePays) !== null && _f !== void 0 ? _f : null;
        }
    }
    /**
     * Utilisée pour renvoyer les informations au back.
     */
    toRaw() {
        return {
            idVille: this.idVille,
            idDepartement: this.idDepartement,
            cp: this.cp,
            libelle: this.libelle,
            libelleUrlRewriting: this.libelleUrlRewriting,
            codePays: this.codePays,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2VvVmlsbGUuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJHZW9WaWxsZS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sT0FBTyxRQUFRO0lBK0JwQixZQUFtQixHQUF1Qjs7UUFDekMsSUFBSSxHQUFHLEVBQUU7WUFDUixJQUFJLENBQUMsT0FBTyxHQUFHLE1BQUEsR0FBRyxDQUFDLE9BQU8sbUNBQUksSUFBSSxDQUFDO1lBQ25DLElBQUksQ0FBQyxhQUFhLEdBQUcsTUFBQSxHQUFHLENBQUMsYUFBYSxtQ0FBSSxJQUFJLENBQUM7WUFDL0MsSUFBSSxDQUFDLEVBQUUsR0FBRyxNQUFBLEdBQUcsQ0FBQyxFQUFFLG1DQUFJLElBQUksQ0FBQztZQUN6QixJQUFJLENBQUMsT0FBTyxHQUFHLE1BQUEsR0FBRyxDQUFDLE9BQU8sbUNBQUksSUFBSSxDQUFDO1lBQ25DLElBQUksQ0FBQyxtQkFBbUIsR0FBRyxNQUFBLEdBQUcsQ0FBQyxtQkFBbUIsbUNBQUksSUFBSSxDQUFDO1lBQzNELElBQUksQ0FBQyxRQUFRLEdBQUcsTUFBQSxHQUFHLENBQUMsUUFBUSxtQ0FBSSxJQUFJLENBQUM7U0FDckM7SUFDRixDQUFDO0lBRUQ7O09BRUc7SUFDSSxLQUFLO1FBQ1gsT0FBTztZQUNOLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTztZQUNyQixhQUFhLEVBQUUsSUFBSSxDQUFDLGFBQWE7WUFDakMsRUFBRSxFQUFFLElBQUksQ0FBQyxFQUFFO1lBQ1gsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPO1lBQ3JCLG1CQUFtQixFQUFFLElBQUksQ0FBQyxtQkFBbUI7WUFDN0MsUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFRO1NBQ3ZCLENBQUM7SUFDSCxDQUFDO0NBQ0QifQ==